import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import get from 'lodash/get';

import Venue from 'models/venue';

const propTypes = {
  venue: PropTypes.instanceOf(Venue),
};

const defaultProps = {
  venue: null,
};

const VenueSubheader = ({ venue }) => {
  if (!get(venue, 'enhancedAirport', false)) { return null; }

  return (
    <div className="text-size-sm-12 text-size-xs-14 text-color-dark-slate text-weight-book margin-bottom-10">
      <span className="text-weight-sm-medium">
        <FormattedMessage
          id="checkout.airport-parking-for"
          defaultMessage="Airport parking for"
        />
      </span> {venue.name}
    </div>
  );
};

VenueSubheader.propTypes = propTypes;
VenueSubheader.defaultProps = defaultProps;
export default VenueSubheader;
